<template #content>
    <Dialog
        :visible="visible"
        @update:visible="updateVisible"
        @show="onShow"
        @hide="onHide"
        class="w-6 lg:w-4"
        modal >
        <template #header>
            <div class="flex justify-content-between flex-wrap w-full">
                <div>
                    <span class="font-bold">Categoria de Pendência</span>
                </div>

                <div class="flex justify-content-end gap-1">
                    <Button
                        v-if="form.id"
                        label="Log"
                        severity="secondary"
                        icon="pi pi-history"
                        size="small"
                        class="flex align-items-center justify-content-center"
                        @click="openLogForm"
                        :loading="isLoading" />
                </div>
            </div>
        </template>
        <form @submit.prevent="onSubmit(form)">

            <div class="w-full">

                <div class="w-12">

                    <div class="field mt-4">
                        <FloatLabel>
                            <InputText id="descricao" v-model="form.descricao" class="w-full" />
                            <label for="descricao">Descrição<span class="text-red-500">*</span></label>
                        </FloatLabel>
                        <div class="text-xs text-red-500">{{ errors['descricao'] }}</div>
                    </div>

                </div>
            </div>

            <div class="flex justify-content-end gap-1">
                <Button type="submit" label="Salvar" severity="success" icon="pi pi-save" size="small"
                    class="flex align-items-center justify-content-center" :loading="isLoading" />
                <Button label="Fechar" severity="warn" icon="pi pi-times" size="small" @click="updateVisible(false)"
                    class="flex align-items-center justify-content-center" :loading="isLoading" />
            </div>
        </form>

        <LogForm :visible="visibleLogForm" table="pendencias" :tableId="form.id" @close="this.visibleLogForm=false" />

    </Dialog>
</template>
<script>
import Dialog from 'primevue/dialog';
import FloatLabel from 'primevue/floatlabel';
import InputText from 'primevue/inputtext';
import Password from 'primevue/password';
import Button from 'primevue/button';
import Select from 'primevue/select';
import Checkbox from 'primevue/checkbox';
import Textarea from 'primevue/textarea';

import PendenciaCategoria from '@/service/pendenciaCategoria.js';

import LogForm from '@/components/LogForm.vue';

export default {
    components: {
        Dialog,
        FloatLabel,
        Button,
        InputText,
        Password,
        Button,
        Select,
        Checkbox,
        Textarea,

        LogForm,
    },
    props: {
        visible: {
            type: Boolean,
            default: false
        },
        data: {
            type: Object,
            default: {}
        },
    },
    emits: ['save', 'close'],
    data() {
        return {
            form: {},
            errors: {},
            isLoading: false,
            categoria: [],
            isLoadingCategoriaOpt: false,



            visibleLogForm: false,
        }
    },
    methods: {
        onShow() {
            this.errors = {};
            this.form = { ...this.data };
        },
        onHide() {
            this.form = {};
        },
        openLogForm() {
            this.visibleLogForm = true;
        },
        updateVisible(visible) {
            this.$emit('close', visible);
        },
        save(form) {
            if (form.id) {
                return PendenciaCategoria.update(form.id, form);
            }
            return PendenciaCategoria.create(form);
        },
        onSubmit(form) {
            this.errors = {};
            this.isLoading = true;
            this.save(form)
                .then(response => {
                    this.$toast.add({ severity: 'success', summary: 'Sucesso', detail: 'Seus dados foram salvos com sucesso.', life: 3000 });
                    this.$emit('save');
                    this.$emit('close');
                })
                .catch(error => {
                    if (error.response) {
                        let err = error.response.data;
                        if (err.erros) {
                            for (let i in err.erros) {
                                this.errors[i] = err.erros[i][0];
                            }
                            return;
                        }
                        if (error.response.data.msg) {
                            this.$toast.add({ severity: 'error', summary: 'Ops!', detail: error.response.data.msg, life: 5000 });
                            return;
                        }
                    }
                    this.$toast.add({ severity: 'error', summary: 'Ops!', detail: error.message, life: 5000 });
                })
                .finally(() => {
                    this.isLoading = false;
                });
        }
    },
}
</script>
